module.exports = __webpack_public_path__ + "static/media/STAROFBETHLEHEM.2b7467ad.JPG";